<template>
	<div>
		<div class="min_cw padding_xl_lr home_coo">
			<HomeTitleItem title="合作伙伴" sub="COOPERATIVE PARTNERS" />

			<div class="home_coo_img">
				<img class="img" :src="$import('cooperative_banner.jpg')" alt="">
			</div>

			<div class="home_coo_swiper_box">
				<swiper res="swiper" class="home_coo_swiper" :options="swiperOptions">
					<swiper-slide v-for="(item, index) in list" :key="index" class="item">
						<AppLink class="img_box" :href="item.cooperative_link">
							<img :src="$http.fileUrl + item.cooperative_pic" alt="">
						</AppLink>
					</swiper-slide>
				</swiper>

				<img class="btn prev" :src="$import('icon_left.png')" alt="">
				<img class="btn next" :src="$import('icon_right.png')" alt="">
			</div>
		</div>
	</div>
</template>

<script>
import HomeTitleItem from "./titleItem"
import {getCooperativeInfoListApi} from "@/api";

export default {
	name: "index",
	components: {
		HomeTitleItem,
	},
	data() {
		return {
			loading: false,
			list: [],
			swiperOptions: {
				slidesPerView: 5, // 多列
				autoplay: true, // 是否自动播放
				navigation: {
					nextEl: '.next',
					prevEl: '.prev',
				},
			}
		}
	},
	created() {
		this.getList();
	},
	methods: {
		async getList() {
			this.loading = true;
			const res = await getCooperativeInfoListApi();
			this.list = res.data;
			this.loading = false;
		},
	},
}
</script>

<style lang="less" scoped>
.home_coo {
	overflow: hidden;
}

.home_coo_img {
	transition: all 1s;
	transform: translateY(0);

	width: 100%;
	height: 0;
	padding-top: calc(100% / 4);
	margin: 0 auto;
	position: relative;

	.img {
		width: 100%;
		height: 100%;
		object-fit: cover;
		position: absolute;
		top: 0;
		left: 0;
	}
}

.home_coo_swiper_box {
	transition: all 1s;
	transform: translateY(0);

	height: 85px;
	position: relative;
	margin-top: 30px;

	.home_coo_swiper {
		width: 100%;
		height: 100%;

		.item {
			height: 100%;
			padding: 0 15px;

			.img_box {
				display: block;
				width: 100%;
				height: 100%;
				background-color: @white;
				border: 1px solid @greyLine;
				position: relative;
				cursor: pointer;
				overflow: hidden;
			}

			img {
				max-width: 90%;
				height: 90%;
				object-fit: contain;
				position: absolute;
				top: 50%;
				left: 50%;
				transform: translate(-50%, -50%);
				transition: all .3s;
			}

			.img_box:hover img {
				transform: translate(-50%, -50%) scale(1.2);
			}
		}
	}

	.btn {
		width: 40px;
		height: 40px;
		object-fit: cover;
		padding: 10px;
		background-color: rgba(255, 255, 255, .8);
		border: 1px solid @greyLine;
		border-radius: 50%;
		position: absolute;
		top: 50%;
		transform: translateY(-50%);
		z-index: 9999;
		cursor: pointer;
		transition: all .5s;
		opacity: 0;
	}

	.prev {
		left: 10px;
	}

	.next {
		right: 10px;
	}
}

.home_coo_swiper_box:hover .btn {
	opacity: 1;
}
</style>
